import {environment} from "../../../environments/environment";
import {TransactionOpaque} from "./opaque/transactionOpaque";

export class InitPaymentRequest {
  clientID: string | null;
  username: string | null;
  password: string | null;
  currency: string | null;
  description: string | null;
  orderID: number | null;
  amount: number | null;
  backURL: string | null;
  opaque: string | null;
  cardHolderID: string | null;
  timeout: number | null;
  isIndividual: boolean | null;
  toUserId?: bigint | null;
  cardUsername?: string | null;
  isMonthly?: boolean | null;
  promoCode?: string | null;
  payWithNewCard?: boolean | null;
  opaqueObj?: TransactionOpaque;
  moneyLuxUuid?: string | null;
  scanMeOrderId?: number | null;
  menuId?: number | null;
  purchasedProducts?: string | null;
  purchasedMenuItems?: { itemId: number; quantity?: number | null }[] | null;
  feePaymentRecordId?: number | null;
  enableRecurringPayment?: boolean | null;

  constructor(
    clientID: string | null, username: string | null, password: string | null,
    currency: string | null, description: string | null, orderID: number | null,
    amount: number | null, backURL: string | null, opaque: string | null,
    cardHolderID: string | null, timeout: number | null, isIndividual: boolean | null,
    toUserId?: bigint | null, cardUsername?: string | null, isMonthly?: boolean | null,
    promoCode?: string | null, payWithNewCard?: boolean | null, moneyLuxUuid?: string | null,
    scanMeOrderId?: number | null, menuId?: number | null, purchasedProducts?: string | null,
    purchasedMenuItems?: { itemId: number; quantity?: number | null }[] | null,
    feePaymentRecordId?: number | null,
    enableRecurringPayment?: boolean | null
  ) {
    this.clientID = clientID;
    this.username = username;
    this.password = password;
    this.currency = currency;
    this.description = description;
    this.orderID = orderID;
    this.amount = amount;
    this.backURL = backURL;
    this.opaque = opaque;
    this.cardHolderID = cardHolderID;
    this.timeout = timeout;
    this.isIndividual = isIndividual;
    this.toUserId = toUserId;
    this.cardUsername = cardUsername;
    this.isMonthly = isMonthly;
    this.promoCode = promoCode;
    this.payWithNewCard = payWithNewCard;
    this.moneyLuxUuid = moneyLuxUuid;
    this.scanMeOrderId = scanMeOrderId;
    this.menuId = menuId;
    this.purchasedProducts = purchasedProducts;
    this.purchasedMenuItems = purchasedMenuItems;
    this.feePaymentRecordId = feePaymentRecordId;
    this.enableRecurringPayment = enableRecurringPayment;
  }

  public static initForCreditCardParing(description: string, price: number) {
    return new InitPaymentRequest(null, null, null, null,
      description, null, price, null,
      null, null, null, null, null, null, null, null, false, null, null);
  }

  public static initForSubscriptionBuying(description: string, price: number, opaque: string, isIndividual: boolean, isMonthly: boolean, promoCode?: string | null) {
    return new InitPaymentRequest(null, null, null, null,
      description, null, price, null,
      opaque, null, null, isIndividual, null, null, isMonthly, promoCode, false, null, null);
  }

  public static initForAdditionalCardsBuying(description: string, price: number, opaque: string, isMonthly: boolean) {
    return new InitPaymentRequest(null, null, null, null,
      description, null, price, null,
      opaque, null, null, null, null, null, isMonthly, null, null, null, null);
  }

  public static initForWalletToWallet(
    description: string,
    amount: number,
    toUserId: bigint,
    cardUsername: string,
    cardHolderId: string,
    moneyLuxUuid: string | null,
    menuId?: number | null,
    purchasedProducts?: string | null,
    purchasedMenuItems?: { itemId: number; quantity?: number | null }[] | null,
    feePaymentRecordId?: number | null,
    enableRecurringPayment?: boolean | null
  ) {
    const backUrl: string = `${environment.frontUrl}payment/receipt`;
    return new InitPaymentRequest(null, null, null, null,
      description, null, amount, backUrl,
      "{}", cardHolderId, null, false, toUserId, cardUsername, null, null, null, moneyLuxUuid, null, menuId, purchasedProducts, purchasedMenuItems, feePaymentRecordId, enableRecurringPayment);
  }

  public static initForProductBuying(amount: number, cardHolderId: string, opaque: any, promoCode?: string, scanMeOrderId?: number | null) {
    return new InitPaymentRequest(
      null, null, null, null,
      null, null, amount, null,
      opaque, cardHolderId, null,
      false, null, null,
      null, promoCode, null, null, scanMeOrderId);
  }
}
